'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const PlayVideoIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="PlayVideoIcon">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.5 12.375L12 9L7.5 5.625V12.375ZM9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9 15C5.6925 15 3 12.3075 3 9C3 5.6925 5.6925 3 9 3C12.3075 3 15 5.6925 15 9C15 12.3075 12.3075 15 9 15Z"
          fill={sx?.color || 'white'}
        />
      </svg>
    </SvgIcon>
  )
}

PlayVideoIcon.propTypes = {
  sx: PropTypes.object
}
